import { upperFirst } from 'lodash'

import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import { UPDATE_FREQUENCY } from 'modules/attendance/lib/enums'

export const handleUpdateFrequencyI18n = (frequency: string): string => {
  if (frequency === UPDATE_FREQUENCY.daily) {
    return upperFirst(
      i18n.t(
        'time_tracking.settings.overtime.compensation.timeoff.form.fields.update_frequency.daily'
      )
    )
  }
  if (frequency === UPDATE_FREQUENCY.weekly) {
    return upperFirst(
      i18n.t(
        'time_tracking.settings.overtime.compensation.timeoff.form.fields.update_frequency.weekly'
      )
    )
  }

  return upperFirst(
    i18n.t(
      'time_tracking.settings.overtime.compensation.timeoff.form.fields.update_frequency.monthly'
    )
  )
}

const updateFrequencies = () => {
  const hasWeeklyBalanceCompensation = hasFeature('dev_time_tracking_weekly_balance_compensation')

  return Object.values(UPDATE_FREQUENCY).filter((updateFrequency) =>
    hasWeeklyBalanceCompensation ? true : updateFrequency !== UPDATE_FREQUENCY.weekly
  )
}

export const updateFrequencyOptions = () => {
  return updateFrequencies().map((frequency) => ({
    label: handleUpdateFrequencyI18n(frequency),
    value: frequency,
  }))
}
